import * as actionTypes from "../actionTypes";

export function setTheme(theme) {
  return { type: actionTypes.SET_THEME, data: theme };
}

export function setTaskLayout(layout) {
  return { type: actionTypes.SET_TASKLAYOUT, data: layout };
}